export default "__VITE_ASSET__wJrvnqIj__"